import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

const ProfileAvatarImg = ({ upload, avatar, completed, profile }) => {
  return (
    <div className={classNames('user-avatar', { loading: upload })}>
      <img
        src={avatar ? `${avatar}?${Date.now()}` : `/office/img/user.svg`}
        className="img-fluid rounded-circle"
        alt=""
      />
      {upload && <span className="progress">{completed}%</span>}
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.webmaster.profile,
});

export default connect(mapStateToProps)(ProfileAvatarImg);
